import { ActionsObservable, ofType, StateObservable } from 'redux-observable';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { NextCoachingService } from '../../../../../coaching-base/coaching.service';
import { ObservationService } from '../../../../../coaching-observation/observation/observation.service';
import { Dependencies } from '../../../../../store';
import { PayloadAction } from '../../../../../store.model';
import { ActionType } from '../teamschat-transcript-dialog.action';

import { Reload, ReloadResult, reloadResult } from './reload.action';

export const reloadEpic = (
    action: ActionsObservable<PayloadAction<ActionType, Reload>>,
    state: StateObservable<any>,
    deps: Dependencies,
): Observable<PayloadAction<ActionType, ReloadResult>> =>
    action.pipe(
        ofType(ActionType.COACHING_DETAIL__TCTD__RELOAD),
        mergeMap((act: PayloadAction<ActionType, Reload>) => {
            const coachingService =
                deps.injector?.get<NextCoachingService>(NextCoachingService);
            const observationService =
                deps.injector.get<ObservationService>(ObservationService);

            return forkJoin([
                of(null).pipe(coachingService.retrieveLookupBox()),
                of(null).pipe(observationService.retrieveObservationConfig()),
            ]).pipe(
                map((ret) => {
                    return reloadResult(
                        {
                            ...act.payload,
                            behaviours: ret[0].behaviours,
                            subBehaviours: ret[0].subBehaviours,
                            observationConfig: ret[1],
                        },
                        act.storePath,
                    );
                }),
                catchError((err) => {
                    console.log(err);
                    return of(null);
                }),
            );
        }),
    );
